module.exports = __webpack_public_path__ + "img/icon-freezer.2044c4a9.svg";